import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PnrInfo, SearchForm } from 'src/app/core/models/itinerary.model';
import { Router } from '@angular/router';
import { SettingsService } from 'src/app/settings/services/settings.service';

@Component({
  selector: 'app-options',
  templateUrl: './options.component.html',
  styleUrls: ['./options.component.scss']
})
export class OptionsComponent {
  @Input() activeTab: string;
  @Input() searchForm: SearchForm;
  @Input() pnr: PnrInfo;
  @Output() navigateTo = new EventEmitter<string>();
  showAirlineNotes = false; 
  constructor(private router: Router, private settingsService: SettingsService) {
    this.settingsService.getClientSettings().subscribe(status=> {
      this.showAirlineNotes = status.showAirlineNotes;
    });

  }

  navigateToHistory() {
    this.router.navigate(['itinerary/history'], {
      queryParams: {
        pnr: this.pnr.code,
        officeId: this.pnr.officeId,
        country: this.pnr.countryCode,
        gds: this.searchForm.gds,
        bookingCode: this.searchForm.bookingCode
      }
    });
  }

  navigateToItineraryHistory() {
    this.router.navigate(['itinerary/itineraryHistory'], {
      queryParams: {
        pnr: this.pnr.code,
        gds: this.searchForm.gds
      }
    });
  }

  navigateToAirCompanyNotes() {
    if(this.showAirlineNotes){
      this.router.navigate(['itinerary/airCompanyNotes'], {
        queryParams: {
          pnr: this.pnr.code,
          officeId: this.pnr.officeId,
          country: this.pnr.countryCode,
          gds: this.searchForm.gds,
          bookingCode: this.searchForm.bookingCode.length ? this.searchForm.bookingCode.length : this.pnr.code
        }
      });
    }
 
  }

  navigateToTicketHistory() {
    this.router.navigate(['itinerary/ticketHistory'], {
      queryParams: {
        pnr: this.pnr.code,
        officeId: this.pnr.officeId,
        country: this.searchForm.country,
        gds: this.searchForm.gds,
        bookingCode: this.searchForm.bookingCode
      }
    });
  }
}
